import { ForgotPasswordTooManyComponent } from '../../components/screens/create-new-password/forgot-password-too-many/forgot-password-too-many.component';
import { TooManyAttemptsSvgComponent } from '../../modules/mapfre-design-library/src/lib/svg/too-many-attempts-svg/too-many-attempts-svg.component';
import { EmailConfirmationComponent } from '../../components/screens/email-confirmation/email-confirmation.component';
import { SendEmailFormComponent } from '../../components/forms/dynamic-forms/send-email-form/send-email-form.component';
import { MapfreAlertComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { MapfreCardComponent } from '../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { HeaderComponent } from '../../modules/mapfre-design-library/src/lib/_components/global-components/header/header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute , RouterModule } from '@angular/router';

import { EmailFormService } from '../../_services/forms/forgot-password/email-form/email-form.service';
import { UserDataService } from '../../_services/data-services/user-data.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, HeaderComponent, MapfreCardComponent, MapfreAlertComponent, SendEmailFormComponent, EmailConfirmationComponent, TooManyAttemptsSvgComponent, ForgotPasswordTooManyComponent],
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  providers: [EmailFormService],
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  emailInputs: any[];
  emailPrefillParamater: string;
  showConfirmationBox = false;
  tooManyAttempts = false;
  isAcmic = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private userService: UserDataService,
    private emailService: EmailFormService,
    private acmicService: AcmicService
  ) {
    this.emailInputs = emailService.getInputs();
  }

  getEmailFromParamater(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.emailPrefillParamater = params['emailPrefill'] || '';
    });
  }

  showConfirmationAction(event): void {
    this.showConfirmationBox = event;
  }

  ngOnInit() {
    if (this.acmicService.isACMIC()) {
      this.isAcmic = true;
    }

    this.getEmailFromParamater();
    this.userService.getConfimationValue().subscribe((data) => {
      this.showConfirmationBox = data;
    });
  }

  ngOnDestroy(): void {
    this.userService.updateConfimationValue(false);
  }
}
